export enum PlaceResultTypeEnum {
  PLACE = "place",
  REGION = "region",
  VENUE = "venue",
}

export enum SitewideResultTypeEnum {
  CONTENT = "content",
  SEARCH = "search",
  PLACE = PlaceResultTypeEnum.PLACE,
  REGION = PlaceResultTypeEnum.REGION,
  VENUE = PlaceResultTypeEnum.VENUE,
}

export enum HomepageSearchResultTypeEnum {
  SEARCH = "search",
  PLACE = PlaceResultTypeEnum.PLACE,
  REGION = PlaceResultTypeEnum.REGION,
  VENUE = PlaceResultTypeEnum.VENUE,
}
